import { infowindow } from './_context.js';
import { resolveDetailUrl } from './_permalink.js';

export function closeInfoWindow(preventCloseActive) {
    if (preventCloseActive && infowindow.getContent().indexOf('infowindow--active') > 0) {
        return;
    }
    infowindow.setContent(infowindow.getContent().replace('infowindow--active', ''));
    infowindow.setContent(infowindow.getContent().replace('infowindow', ''));
    infowindow.close();
}

export function generateInfoWindowContent(e) {
    let htmlContent = '';
    if (infoWindowCallback !== '') {
        htmlContent = window[infoWindowCallback].call(this, e);
    } else {
        const categArray = e.categ ? e.categ.split('|') : [];
        let categString = '';
        Array.prototype.forEach.call(categArray, function (c) {
            if (c != '') {
                if (c.includes('~')) {
                    c = c.split('~');
                    categString += '<div class="map-badge" style="background:' + c[0] + '">' + c[1] + '</div>';
                } else {
                    categString += '<div class="map-badge">' + c + '</div>';
                }
            }
        });
        let title = '';
        if (e.rue_travaux) {
            title = '<div class="infowindow__rue-travaux"><strong>' + e.rue_travaux + '</strong></div>';
        } else {
            title = e.title;
        }
        let extraInfos = '';
        if (e.rue) {
            extraInfos += '<div class="infowindow__rue"><strong>Rue:</strong> ' + e.rue + '</div>';
        }
        if (e.date) {
            extraInfos +=
                '<div class="infowindow__date"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.8327 3.33317H14.166V2.49984C14.166 2.0396 13.7929 1.6665 13.3327 1.6665C12.8724 1.6665 12.4993 2.0396 12.4993 2.49984V3.33317H7.49935V2.49984C7.49935 2.0396 7.12625 1.6665 6.66602 1.6665C6.20578 1.6665 5.83268 2.0396 5.83268 2.49984V3.33317H4.16602C2.7853 3.33317 1.66602 4.45246 1.66602 5.83317V15.8332C1.66602 17.2139 2.7853 18.3332 4.16602 18.3332H15.8327C17.2134 18.3332 18.3327 17.2139 18.3327 15.8332V5.83317C18.3327 4.45246 17.2134 3.33317 15.8327 3.33317ZM16.666 15.8333C16.666 16.2935 16.2929 16.6666 15.8327 16.6666H4.16603C3.70579 16.6666 3.33269 16.2935 3.33269 15.8333V9.99994H16.666V15.8333ZM16.666 8.33327H3.33269V5.83327C3.33269 5.37304 3.70579 4.99994 4.16603 4.99994H5.83269V5.83327C5.83269 6.29351 6.20579 6.66661 6.66603 6.66661C7.12627 6.66661 7.49936 6.29351 7.49936 5.83327V4.99994H12.4994V5.83327C12.4994 6.29351 12.8725 6.66661 13.3327 6.66661C13.7929 6.66661 14.166 6.29351 14.166 5.83327V4.99994H15.8327C16.2929 4.99994 16.666 5.37304 16.666 5.83327V8.33327Z" fill="#0064BD"/></svg><strong>Date:</strong> ' +
                e.date +
                '</div>';
        }
        if (e.plan_de_detour) {
            extraInfos +=
                '<div class="infowindow__plan-detour"><a href="' +
                e.plan_de_detour +
                '" target="_blank"><strong>Plan de détour</strong></a></div>';
        }
        if (!useDataPanel) {
            if (e.address) {
                extraInfos += '<div class="infowindow__address">' + e.address + '</div>';
            }
            if (e.telephone) {
                extraInfos +=
                    '<div class="infowindow__telephone"><strong>Téléphone:</strong> <a href="tel:' +
                    e.telephone.replace(/\s/g, '') +
                    '">' +
                    e.telephone +
                    '</a></div>';
            }
            if (e.email) {
                extraInfos += '<div class="infowindow__email"><strong>Courriel:</strong> ' + e.email + '</div>';
            }
            const detailUrl = resolveDetailUrl(e);
            if (detailUrl) {
                let buttonClass = '';
                if (document.body.classList.contains('wp-theme-bricks')) {
                    buttonClass = 'btn btn--primary btn--xs';
                } else {
                    buttonClass = 'button button--primary';
                }
                extraInfos +=
                    '<div class="infowindow__link"><a href="' +
                    detailUrl +
                    '" class="' +
                    buttonClass +
                    '" target="_blank" rel="noopener">En savoir plus</a></div>';
            }
        }
        htmlContent =
            '<div class="infowindow__categ map-badges">' +
            categString +
            '</div><div class="infowindow__title">' +
            title +
            '</div>' +
            extraInfos;
    }

    const closeButton = document.querySelector('.js-close-data-panel').cloneNode(true);
    var wrap = document.createElement('div');
    wrap.appendChild(closeButton);
    closeButton.classList.add('infowindow__close');
    closeButton.classList.add('icon-button--small');
    const infowindowContent = '<div class="infowindow">' + wrap.innerHTML + htmlContent + '</div>';
    return infowindowContent;
}
